import React from 'react'

import './style.scss'

class CurrentTagTitle extends React.Component {
  render() {
    let tagName = ''
    if (this.props.currentTag === 'quiz') {
      tagName = 'тесты'
    } else {
      tagName = this.props.factsTags.filter((obj) => {
        return obj.id === this.props.currentTag
      })[0].name
    }

    return (
      <div
        className="current-tag-title"
      >
        <div dangerouslySetInnerHTML={{__html: tagName}}/>
        <span onClick={() => this.props.getFactsDataByTag('all')}/>
      </div>
    )
  }
}

export default CurrentTagTitle
